import { render, staticRenderFns } from "./declarateRecordDialog.vue?vue&type=template&id=30926854&"
import script from "./declarateRecordDialog.vue?vue&type=script&lang=js&"
export * from "./declarateRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./declarateRecordDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30926854')) {
      api.createRecord('30926854', component.options)
    } else {
      api.reload('30926854', component.options)
    }
    module.hot.accept("./declarateRecordDialog.vue?vue&type=template&id=30926854&", function () {
      api.rerender('30926854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/edi/declarateRecordDialog.vue"
export default component.exports